<form [formGroup]="targetForm">
    <section class="sideRight-body">
       <div>
        <label>
            <textarea size="5" rows="7" cols="75" maxlength="3000" name="comment" no-special-chars="#!$%^<>+='" (blur)="trimSpecialChar('comment');"  formControlName="comment" (input)= "onAddComment()" required class="textarea textarea-width"></textarea>
        </label>
        <section class="btn-section">
            <button type='button' class="btn btn-secondary" [disabled]="!targetForm.valid || isDisabled" (click)="addComment()"><i class="fa fa-plus mr-2"></i> Add Comment</button> 
        </section>
       </div>
        <section class="comments-container info-tile-alt">
            <div class="comment-row" *ngFor="let item of comments">
                <div class="commented-time">{{item.commentedOn | tolocaldate}}</div>
                <div class="commented-by">{{item.commentedBy}}</div>
                <div class="comment">
                    <p>
                        {{item.comments}}
                    </p>
                </div>        
            </div>
        </section>
    </section>
</form>
